import { DefaultTheme } from 'styled-components'

export const darkTheme: DefaultTheme = {
    toggleBorder: '#6B8096',
    background: '#999',
    colors: {
        body: '#1b1a1b',
        text: '#f9f9f9',
        logo: '#000000'
      },
}